import DateAndTime from 'date-and-time';

import { fnIsDateTimeWithinRange } from 'utils/common';

// Formats to: Wednesday, July 27, 2022 at 10:07 AM
const sDateTimeFormat = 'dddd, MMMM D, YYYY at h:mm A';

// Formats to: Wednesday, July 27, 2022
const sDateOnlyFormat = 'dddd, MMMM D, YYYY';

/**
 * Formats a date string into a human-readable date.
 *
 * @param {string} sDate - Date string with or without time
 * @returns {string} - Formatted date.
 */
const fnFormatDate = (sDate = '') => {
  let sFormatted = '';
  if (sDate) {
    const oDate = new Date(sDate);
    const bDateIncludesTime = sDate.includes('T');
    const sFormat = bDateIncludesTime ? sDateTimeFormat : sDateOnlyFormat;
    sFormatted = DateAndTime.format(oDate, sFormat);
  }
  return sFormatted;
};

// Splits a message on **bold** markers into ordered segments for rendering
export const fnSplitBoldSegments = (sMessage = '') =>
  sMessage
    .split(/\*\*(.+?)\*\*/)
    .map((sText, nIndex) => ({ sText, bBold: nIndex % 2 === 1 }))
    .filter((oSegment) => oSegment.sText !== '');

export const fnIsAnnouncementAlert = (oAlert) =>
  oAlert?.M?.type?.S === 'announcement';

// Finds a maintenance downtime starting within the next 2 days
export const fnFindUpcomingMaintenanceAlert = (aAlerts = []) =>
  aAlerts.find((oAlert) => {
    if (fnIsAnnouncementAlert(oAlert)) {
      return false;
    }
    const sStart = oAlert.M.start.S;
    const oTwoDaysBeforeStart = new Date(sStart);
    oTwoDaysBeforeStart.setDate(oTwoDaysBeforeStart.getDate() - 2);
    return fnIsDateTimeWithinRange(
      Date.now(),
      oTwoDaysBeforeStart.toDateString(),
      sStart
    );
  });

// Finds a maintenance downtime happening right now
export const fnFindActiveMaintenanceAlert = (aAlerts = []) =>
  aAlerts.find(
    (oAlert) =>
      !fnIsAnnouncementAlert(oAlert) &&
      fnIsDateTimeWithinRange(Date.now(), oAlert.M.start.S, oAlert.M.end.S)
  );

// Finds an announcement whose display window is happening right now
export const fnFindActiveAnnouncementAlert = (aAlerts = []) =>
  aAlerts.find(
    (oAlert) =>
      fnIsAnnouncementAlert(oAlert) &&
      fnIsDateTimeWithinRange(Date.now(), oAlert.M.start.S, oAlert.M.end.S)
  );

export default fnFormatDate;
